module.exports = __webpack_public_path__ + "images/花筑pr长图_04-2.jpg?v=78c0a63b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_04-2.jpg
 ** module id = 15
 ** module chunks = 1 2
 **/